export const STATUS_TABS = [
  { key: "", label: "Tất cả" },
  { key: "pending", label: "Chờ xử lý" },
  { key: "draft", label: "Nháp" },
  { key: "pending_sign_coo", label: "Chờ COO ký" },
  { key: "pending_approve_coo", label: "Chờ COO duyệt" },
  { key: "pending_sign_ceo", label: "Chờ CEO ký" },
  { key: "signed", label: "Đã ký" },
  { key: "completed", label: "Hoàn tất" },
  { key: "rejected", label: "Từ chối" },
];

export const STATUS_BADGE = {
  draft: "bg-slate-100 text-slate-600 border-slate-200",
  pending: "bg-amber-100 text-amber-800 border-amber-200",
  pending_sign_coo: "bg-amber-100 text-amber-800 border-amber-200",
  pending_approve_coo: "bg-amber-100 text-amber-800 border-amber-200",
  pending_sign_ceo: "bg-orange-100 text-orange-800 border-orange-200",
  signed: "bg-blue-100 text-blue-800 border-blue-200",
  completed: "bg-emerald-100 text-emerald-800 border-emerald-200",
  rejected: "bg-red-100 text-red-700 border-red-200",
};

export const STATUS_LABEL = Object.fromEntries(
  STATUS_TABS.filter((t) => t.key).map((t) => [t.key, t.label])
);

export const PENDING_STATUS_LABEL = {
  pending_sign_coo: "Chờ COO ký",
  pending_approve_coo: "Chờ COO duyệt",
  pending_sign_ceo: "Chờ CEO ký",
};

export const ACTION_LABEL = {
  created: "Tạo yêu cầu",
  submitted: "Trình ký",
  coo_approved: "COO duyệt",
  signed: "Đã ký",
  rejected: "Từ chối",
  notified: "Gửi thông báo",
  email_sent: "Gửi email",
};

export const SIGNER_ROLE_OPTIONS = [
  { value: "COO", label: "COO ký trực tiếp", hint: "COO xem PDF, đặt chữ ký và ký ngay" },
  { value: "CEO", label: "CEO ký (COO duyệt trước)", hint: "COO duyệt trình ký → CEO ký" },
];

export const DOCUMENT_TYPE_OPTIONS = [
  { value: "quyet_dinh", label: "Quyết định" },
  { value: "nghi_quyet", label: "Nghị quyết" },
  { value: "cong_van", label: "Công văn" },
  { value: "thong_bao", label: "Thông báo" },
  { value: "to_trinh", label: "Tờ trình" },
  { value: "hop_dong", label: "Hợp đồng / Phụ lục" },
  { value: "bien_ban", label: "Biên bản" },
  { value: "bao_cao", label: "Báo cáo" },
  { value: "khac", label: "Khác" },
];

export const DOCUMENT_TYPE_LABEL = Object.fromEntries(
  DOCUMENT_TYPE_OPTIONS.map((o) => [o.value, o.label])
);

export const URGENCY_OPTIONS = [
  { value: "normal", label: "Bình thường", color: "bg-slate-100 text-slate-600 border-slate-200" },
  { value: "urgent", label: "Khẩn", color: "bg-amber-100 text-amber-800 border-amber-200" },
  { value: "very_urgent", label: "Hỏa tốc", color: "bg-red-100 text-red-700 border-red-200" },
];

export const URGENCY_LABEL = Object.fromEntries(
  URGENCY_OPTIONS.map((o) => [o.value, o.label])
);
